import { atom } from 'recoil';

export const signUpStatusState = atom({
    key: 'signUpStatusState',
    default: false,
});
